import * as React from "react";

import {
	List,
	Datagrid,
	ListProps,
	DateField,
	TextField,
	ReferenceField,
	FunctionField,
	TopToolbar,
	ExportButton,
	downloadCSV,
} from "react-admin";
// @ts-ignore
import jsonExport from "jsonexport/dist";

import Pagination from "../Components/Pagination";

const formatUserRole = (role: string) => {
	if (role === "doctor_sale.doctor") {
		return "پزشک";
	} else if (role === "sport_coach.coach") {
		return "مربی";
	} else {
		return "test";
	}
};

const exporter = (patients: any, fetchRelatedRecords: any) => {
	fetchRelatedRecords(patients, "doctorSale.id", "DoctorSale").then(
		(doctorSales: any) => {
			const data = patients.map((patient: any) => {
				if (typeof patient.doctorSale !== "undefined") {
					return {
						...patient,
						doctorSale_date: doctorSales[patient.doctorSale.id]["saleDate"],
					};
				}
				return {
					...patient,
				};
			});

			const patientForExport = data.map((patient: any) => {
				const {
					archived,
					doctorId,
					id,
					sentToLimoome,
					doctorSale,
					updatedAt,
					"doctorSale.id": doctorSale_id,
					...patientForExport
				} = patient; // omit backlinks and author
				if (typeof patientForExport.doctorSale_date !== "undefined") {
					const doctorSaleDate = new Date(patientForExport.doctorSale_date);
					patientForExport.doctorSale_date = new Intl.DateTimeFormat("fa-IR", {
						timeStyle: "short",
						dateStyle: "short",
					}).format(doctorSaleDate);
				}
				const createdAtDate = new Date(patientForExport.createdAt);
				// const updatedAtDate = new Date(patientForExport.updatedAt);

				patientForExport.createdAt = new Intl.DateTimeFormat("fa-IR", {
					timeStyle: "short",
					dateStyle: "short",
				}).format(createdAtDate);
				// patientForExport.updatedAt = new Intl.DateTimeFormat("fa-IR", {
				// 	timeStyle: "short",
				// 	dateStyle: "short",
				// }).format(updatedAtDate);
				if (typeof patientForExport.doctor !== "undefined") {
					const { role, firstName, lastName } = patientForExport.doctor;
					patientForExport.doctor = {
						firstName,
						lastName,
						role: formatUserRole(role),
					};
					return patientForExport;
				}

				return patientForExport;
			});

			jsonExport(
				patientForExport,
				{
					headers: [
						"firstName",
						"lastName",
						"mobile",
						"doctor.firstName",
						"doctor.lastName",
						"doctorComment",
						"doctor.role",
						"saleRepresentativeComment",
						"createdAt",
						"doctorSale_date",
					],
					rename: [
						"نام",
						"نام خانوادگی",
						"موبایل",
						"نام ثبت کننده",
						"نام خانوادگی ثبت کننده",
						"توضیحات ثبت کننده",
						"نقش ثبت کننده",
						"توضیحات اپراتور",
						"تاریخ ثبت",
						"تاریخ فروش",
					],
				},
				(err: any, csv: any) => {
					downloadCSV(csv, "usersList"); // download as 'posts.csv` file
				}
			);
		}
	);
};

const ListActions = () => {
	return (
		<TopToolbar>
			<ExportButton />
		</TopToolbar>
	);
};

export const PatientList = (props: ListProps): React.ReactElement => {
	return (
		<List
			{...props}
			bulkActionButtons={false}
			perPage={50}
			actions={<ListActions />}
			pagination={<Pagination />}
			title={"لیست کل کاربران"}
			exporter={exporter}
		>
			<Datagrid>
				<FunctionField
					label={"نام و نام خانوادگی"}
					render={(record: any) => `${record.firstName} ${record.lastName}`}
				/>
				<TextField label="موبایل" source="mobile" sortable={false} />
				<FunctionField
					label={"نام و نام خانوادگی ثبت کننده"}
					render={(record: any) => {
						return record.doctor
							? `${record.doctor.firstName} ${record.doctor.lastName}`
							: null;
					}}
				/>
				<TextField
					style={{
						whiteSpace: "pre-line",
					}}
					label={"توضیحات ثبت کننده"}
					source="doctorComment"
					sortable={false}
				/>
				<FunctionField
					label={"نقش ثبت کننده"}
					render={(record: any) => {
						return record.doctor
							? `${formatUserRole(record.doctor.role)}`
							: null;
					}}
				/>

				<TextField
					label="توضیحات اپراتور"
					source="saleRepresentativeComment"
					sortable={false}
				/>

				<DateField label="تاریخ ثبت" source="createdAt" locales={"fa-IR"} />
				<ReferenceField
					link={false}
					label="تاریخ خرید"
					source="doctorSale.id"
					reference="DoctorSale"
					sortable={false}
				>
					<DateField source="saleDate" locales={"fa-IR"} />
				</ReferenceField>
			</Datagrid>
		</List>
	);
};
